import React from "react";
import { Link } from "react-router-dom";
import classes from "./ButtonLink.module.css";

export default function ButtonLink(props) {
  return (
    <Link
      to={props.to}
      className={`${classes.buttonLink} ${props.class && props.class}`}
      style={props.style}
    >
      {props.children}
    </Link>
  );
}
